<script>
    export default {
        methods: {
            $can(permissionName) {
                return Permissions.indexOf(permissionName) !== -1;
            },
            $hasRole(roleName) {
                return Roles.indexOf(roleName) !== -1;
            },
            $getIdUser() {
                return RoleID;
            }
        },
    };
</script>